import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    overflow-x: hidden;\n    overflow-y: auto;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 70px;\n    color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin: 4px 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n                ", "\n            "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n\n    &::after {\n        content: '';\n\n        ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &,\n    & > input {\n        cursor: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { triangle } from 'polished';
import { Typography } from '../Typography';
import { TextField } from '../TextField';
import { Balloon } from '../Balloon';
import { Loader } from '../Loader';
import { List } from '../List';
import { noop } from '../helpers';
var StyledTextField = styled(TextField)(_templateObject(), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'default' : 'pointer';
});
var Triangle = styled.div(_templateObject2(), function (_ref2) {
  var _ref2$theme$palette = _ref2.theme.palette,
      gray = _ref2$theme$palette.gray,
      primary = _ref2$theme$palette.primary,
      opened = _ref2.opened,
      disabled = _ref2.disabled;
  return css(_templateObject3(), triangle({
    pointingDirection: opened ? 'top' : 'bottom',
    width: '8px',
    height: '5px',
    foregroundColor: disabled ? gray.gray200 : primary.main
  }));
});
var OptionsList = styled(List)(_templateObject4());
var EmptyPlaceholder = styled(Typography)(_templateObject5(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.gray.gray900;
});
var MenuWrapper = styled.div(_templateObject6());
export function Select(_a) {
  var children = _a.children,
      value = _a.value,
      loading = _a.loading,
      disabled = _a.disabled,
      menuMaxHeight = _a.menuMaxHeight,
      emptyPlaceholder = _a.emptyPlaceholder,
      _a$usePortal = _a.usePortal,
      usePortal = _a$usePortal === void 0 ? true : _a$usePortal,
      _a$onClick = _a.onClick,
      onClick = _a$onClick === void 0 ? noop : _a$onClick,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      props = __rest(_a, ["children", "value", "loading", "disabled", "menuMaxHeight", "emptyPlaceholder", "usePortal", "onClick", "onChange"]);

  var refInput = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setIsOpened = _useState2[1];

  var toggleDropdown = useCallback(function () {
    if (!disabled) {
      var currentValue = !isOpened;
      onClick({
        value: currentValue
      });
      setIsOpened(currentValue);
    }
  }, [isOpened, setIsOpened, disabled, onClick]);
  var closeDropdown = useCallback(function () {
    return setIsOpened(false);
  }, [setIsOpened]);
  var selectedOption;
  React.Children.forEach(children, function (option) {
    if (option && option.props.value === value) {
      selectedOption = option;
    }
  });
  var selectOption = useCallback(function (_ref4) {
    var value = _ref4.value;
    onChange({
      value: value
    });
    closeDropdown();
  }, [onChange, value, closeDropdown]);
  var DropDownContent = loading || !React.Children.count(children) ? React.createElement(EmptyPlaceholder, {
    component: 'div'
  }, loading ? React.createElement(Loader, null) : emptyPlaceholder) : React.createElement(MenuWrapper, {
    style: {
      maxHeight: menuMaxHeight
    }
  }, React.createElement(OptionsList, null, React.Children.map(children, function (Child) {
    return Child && React.cloneElement(Child, {
      selected: Child.props.value === value,
      onClick: selectOption
    });
  })));
  return React.createElement(Balloon, {
    content: DropDownContent,
    opened: isOpened,
    placement: 'bottom',
    showArrow: false,
    onOutsideClick: closeDropdown,
    offsetY: 5,
    fitWidthToTarget: true,
    usePortal: usePortal
  }, function (_ref5) {
    var ref = _ref5.ref;
    return React.createElement(StyledTextField, Object.assign({}, props, {
      value: selectedOption ? typeof selectedOption.props.children === 'string' ? selectedOption.props.children : selectedOption.props.text : '',
      ref: ref,
      inputRef: refInput,
      type: 'text',
      disabled: disabled,
      readOnly: true,
      postfix: React.createElement(Triangle, {
        opened: isOpened,
        disabled: disabled
      }),
      onClick: toggleDropdown
    }));
  });
}